export default __webpack_public_path__ + "static/media/green-landing.8051e86a.webp";